import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiService = new CrudCustom('/transaksis');
export default TransaksiService;
